import { Box, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import { useEffect } from "react";
import { fDate, useDateUtils } from "../../../utils/formatTime";
import { useState } from "react";

export default function WalkinDetailsPopup({
  detailsData,
  isDownloadAccess,
  selectedData,
  fromDate,
  toDate,
  selectedFilter,
  userpopup,
  branchPopup
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  const userRole = localStorage.getItem("userRole");
  const [exportData, setExportData] = useState([]);
  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.first_name || ""} ${
          params.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <Box
          style={{ color: "#2196F3", cursor: "pointer" }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row?.enquiry_id?.id}`,
              "_blank"
            )
          }
        >
          {params.row?.enquiry_id?.first_name}{" "}
          {params.row?.enquiry_id?.last_name}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.enquiry_id?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },

    {
      field: "walkin_type",
      headerName: "Walkin Type",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography> {params.row?.type_of_walking} </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "walk_in_status",
      headerName: "Walkin Staus",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.walk_in_status || "",
      renderCell: (params) => <Box>{params.row?.walk_in_status}</Box>,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "walk_in_on",
      headerName: "Walkin Date",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.appointment_date || "",
      renderCell: (params) => <Box> {params.row?.appointment_date}</Box>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "branch",
      headerName: "Branch",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.branch_visited_id?.branch_name || "",
      renderCell: (params) => (
        <Box>{params.row?.branch_visited_id?.branch_name}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.sub_service_id?.name || "",
      renderCell: (params) => <Box>{params.row?.sub_service_id?.name}</Box>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "prospective_level",
      headerName: "Prospective Level",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => (
        <Box>
          {params.row?.enquiry_id?.prospective_level_id?.prospective_level}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "stage",
      headerName: "Stage",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.stage_id?.stage_name || "",
      renderCell: (params) => (
        <Box>{params.row?.enquiry_id?.stage_id?.stage_name}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "lead_source",
      headerName: "Lead Source",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.lead_source_type_id?.name || "",
      renderCell: (params) => (
        <Box>{params.row?.enquiry_id?.lead_source_type_id?.name}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "reason",
      headerName: "Reason For Walkin",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.event_reason_id?.reason_name || "",
      renderCell: (params) => (
        <Box>{params.row?.event_reason_id?.reason_name}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "register_by",
      headerName: "Walk in Register By",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.created_by?.first_name || ""} ${
          params.row?.created_by?.last_name || ""
        }`,
      renderCell: (params) => (
        <Box>
          {params.row?.created_by?.first_name}{" "}
          {params.row?.created_by?.last_name}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "reference_by",
      headerName: "Walk in Reference By",
      width: 200,
      headerClassName: "header-cell",

      valueGetter: (params) => params.row?.reference_walkin_id?.name || "",
      renderCell: (params) => (
        <Box>
          {params.row?.reference_walkin_id?.name}{" "}
          {params.row?.reference_employee_id?.first_name}{" "}
          {params.row?.reference_employee_id?.last_name}{" "}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "assin_to",
      headerName: "Assign to",
      width: 200,
      headerClassName: "header-cell",

      valueGetter: (params) =>
        `${params.row?.assign_to?.first_name || ""} ${
          params.row?.assign_to?.last_name || ""
        }`,
      renderCell: (params) => (
        <Box>
          {params.row?.assign_to?.first_name} {params.row?.assign_to?.last_name}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },
  {
      field: "appointment_for",
      headerName: "Appointment For",
      width: 200,
      headerClassName: "header-cell",

      valueGetter: (params) =>
        `${params.row?.appointment_for?.first_name || ""} ${
          params.row?.appointment_for?.last_name || ""
        }`,
      renderCell: (params) => (
        <Box>
          {params.row?.appointment_for?.first_name} {params.row?.appointment_for?.last_name}
        </Box>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "walk_in_event",
      headerName: "Walkin Event",
      width: 450,
      headerClassName: "header-cell",
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.event_id?.campaign_name || "",

      renderCell: (params) => <Box>{params.row?.event_id?.campaign_name}</Box>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "last_folloup",
      headerName: "Last Follwup",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.last_follow_up_date || "",
      renderCell: (params) => (
        <Box>{params.row?.enquiry_id?.last_follow_up_date}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "date",
      headerName: "Next Due Date",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.next_follow_up_date || "",
      renderCell: (params) => (
        <Box>{params.row?.enquiry_id?.next_follow_up_date}</Box>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  // Export data
  useEffect(() => {
    const exportData = detailsData.map((row) => ({
      name: row.enquiry_id?.last_name
        ? `${row.enquiry_id?.first_name} ${row.enquiry_id.last_name}`
        : row.enquiry_id?.first_name,
      mobile: row.enquiry_id?.mobile,
      walk_in_status: row?.walk_in_status,
      walk_in_type: row?.type_of_walking,
      branch_visited: row.branch_visited_id?.branch_name || "",
      registered_by: row?.created_by?.first_name,
      walkin_date: fDate(row?.appointment_date),
      time: row?.appointment_time,
      reason_of_visit: row?.event_reason_id?.reason_name,
      event_name: row?.event_id?.campaign_name || "",
      prospective_level:
        row.enquiry_id?.prospective_level_id?.prospective_level || "",
      sub_service: row.sub_service_id?.name || "",
      assign: row.assign_to?.first_name || "",
      lead_source_type: row.enquiry_id?.lead_source_type_id?.name || "",
      reference_by: row?.reference_walkin_id?.name || "",
      stage: row.enquiry_id?.stage_id?.stage_name || "",
    }));
    setExportData(exportData);
  }, [detailsData]);
  return (
    <>
      <Grid container>
        <Grid xs={12} md={6} container gap={4}>
          <Box display="flex" alignItems="center">
               {userpopup && (
                <>
            <Typography variant="h5">Lead Owner :</Typography>
         
              <Typography textAlign="center" ml={0.5}>
                {selectedData?.first_name} {selectedData?.last_name}
              </Typography>
              </>
            )}
            {branchPopup && (
               <>
            <Typography variant="h5">Branch Name :</Typography>
         
              <Typography textAlign="center" ml={0.5}>
                {selectedData?.branch_name} 
              </Typography>
              </>
            )}
         
          </Box>

          <Box display="flex" alignItems="center">
            <Typography variant="h5">Walkin Date :</Typography>
            {selectedFilter === "today" && (
              <Typography textAlign="center" ml={0.5}>
                Today ({currentDate})
              </Typography>
            )}
            {selectedFilter === "currentweek" && (
              <Typography textAlign="center" ml={0.5}>
                This Week ({weekRange})
              </Typography>
            )}

            {selectedFilter === "currentmonth" && (
              <Typography textAlign="center" ml={0.5}>
                {currentMonthName} {currentYear}
              </Typography>
            )}

            {selectedFilter === "custom" && (
              <Typography textAlign="center" ml={0.5}>
                {fromDate} - {toDate}
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6} textAlign="end">
          {isDownloadAccess && (
            <CSVExport
              data={exportData}
              filename="subservice-walkin-report.csv"
            />
          )}
        </Grid>
        <Grid item xs={12} lg={12} sm={12} md={12}>
          <DataGrid
            rows={detailsData}
            columns={columns}
            autoHeight
            slots={{
              noRowsOverlay: () => (
                <CustomNoRowsOverlay message="No Data Available" />
              ),
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
